<div class="content-compact"
[ngClass]="AppSettings.IsRunningInSingularity ? 'content-compact-sso' : ''">
    <div class="shiftSetup-header"
    [ngClass]="AppSettings.IsRunningInSingularity ? 'shiftSetup-header-sso' : ''">
        <div class="row d-flex no-gutters align-items-center flex-nowrap justify-content-between">
            <div class="col-auto form-inline">
                <select title="{{'TITLE.TITLE_SELECT_PROPERTY' | translate}}" class="custom-select mr-2" id="Property"
                        [ngModel]="Model.PropertyId" [hidden]="masterService.LoggedInUserData.Properties.length < 2"
                        (change)="PropertyChanged($event)">
                    <option *ngFor="let row of PropertyList" [value]="row.PropertyId">{{row.PropertyName}}</option>
                </select>
                <select title="{{'TITLE.TITLE_SELECT_DEPARTMENT' | translate}}" class="custom-select mr-2"
                        [ngModel]="Model.DeptId" (change)="DeptChanged($event);">
                    <option [value]="0" disabled translate>CMB_DEF.CMB_DEF_CHOOSE_DEPT</option>
                    <option *ngFor="let row of deptList" [value]="row.Id">
                        {{row.Name}}
                    </option>
                </select>
                <button title="{{'TITLE.TITLE_SETUP_SHIFT' | translate}}" class="btn btn-success pl-2 mr-2"
                        (click)="Model.SectionId = 0; Model.SkillId = 0; staffSkillSection.Open(Model)"
                        *ngIf="Model.DeptId != 0" translate>
                    BTN.BTN_MAP_USER_TO_SECTION
                </button>
                <button title="{{'TITLE.TITLE_SAVE_ACTIVATE' | translate}}"
                        class="btn btn-default border border-danger bg-white text-danger font-weight-bold mr-2"
                        id="saveShift1" (click)="SaveShift()"
                        *ngIf="(CheckAuth_Dept_Action(Model.PropertyId, Model.DeptId, _AuthActionCodes.SaveShift)|| CheckAuth_Dept_Action(Model.PropertyId, Model.DeptId, _AuthActionCodes.ShiftActivate)) && Model.DeptId != 0">
                    <!--<i class="fas fa-save fa-fw"></i>-->{{'BTN.BTN_SAVE' | translate}}/{{'BTN.BTN_ACTIVATE' | translate}}
                </button>
                <div class="btn-group d-flex align-items-center">
                    <button class="btn btn-default border bg-white collapseIcon" [disabled]="StartAllCollapsed"
                            title="{{'TITLE.TITLE_EXPAND_ALL' | translate}}" (click)="ToggleAllSection(true)">
                        <i class="fas fa-plus fa-fw"></i>
                    </button>
                    <button class="btn btn-default border bg-white collapseIcon"
                            title="{{'TITLE.TITLE_COLLAPSE_ALL' | translate}}" (click)="ToggleAllSection(false)">
                        <i class="fas fa-minus fa-fw"></i>
                    </button>
                </div>
                <!--<button class="btn btn-success pl-2 mr-2" type="button" id="activateShift" *ngIf="CheckAuth_Dept_Action(Model.PropertyId, Model.DeptId, _AuthActionCodes.ShiftActivate)"
                        (click)="ActivateShift()" [disabled]="Model.ShiftId && Model.ShiftId == ShiftResponseModel.ActiveShiftId" translate>
                    BTN.BTN_ACTIVATE_SHIFT
                </button>-->
            </div>
            <div class="col-auto btn-group align-items-center form-inline">
                <select class="custom-select mr-2" [ngModel]="Model.ShiftId" (change)="ShiftChange($event)"
                        *ngIf="Model.DeptId != 0 && shiftList && shiftList.length != 0">
                    <option *ngIf="!Model.ShiftId && Model.ShiftId != 0" [value]="null">{{Model.ShiftName}}</option>
                    <option *ngFor="let row of shiftList" [value]="row.ShiftId">
                        {{row.ShiftName}} {{row.IsActive}}
                    </option>
                </select>
                <select *ngIf="Model.DeptId != 0" class="custom-select mr-4" [ngModel]="Model.PerShiftSkillEnabled" (change)="ShiftSkillOptionChange($event)">
                    <option [value]="ShiftSetupLoadOptions.CommonSkills">{{ 'LBL.LBL_COMMON_SHIFT' | translate}}</option>
                    <option [value]="ShiftSetupLoadOptions.ShiftSkills">{{ 'LBL.LBL_SHIFT_SKILLS' | translate}}</option>
                </select>
                <button class="btn btn-default border bg-white"
                        title="{{'TITLE.TITLE_MULTIPLE_LOGIN_LOGOUT' | translate}}"
                        *ngIf="CheckAuth_Dept_Action(Model.PropertyId, Model.DeptId, _AuthActionCodes.ServiceStaff_Login_Logout)"
                        (click)="multipleLoginLogout.Open(Model)" translate>
                    <i class="fas fa-user-friends fa-fw"></i>
                </button>
                <button class="btn btn-default border bg-white" (click)="deleteObject.Open(Model.ShiftName, Model)"
                        [disabled]="Model.ShiftId == ShiftResponseModel.ActiveShiftId"
                        *ngIf="CheckAuth_Dept_Action(Model.PropertyId, Model.DeptId, _AuthActionCodes.SaveShift)"
                        title="{{'TITLE.TITLE_DELETE_SHIFT' | translate}}">
                    <i class="fas fa-trash fa-fw"></i>
                </button>
                <button class="btn btn-default border bg-white" title="{{'TITLE.TITLE_EDIT_SHIFT_NAME' | translate}}"
                        (click)="EditShiftName()" [disabled]="Model.ShiftName == ''"
                        *ngIf="CheckAuth_Dept_Action(Model.PropertyId, Model.DeptId, _AuthActionCodes.SaveShift)">
                    <i class="fas fa-pencil-alt fa-fw"></i>
                </button>
                <button class="btn btn-default border bg-white pl-2" id="newShift" (click)="CreateNewShift()"
                        title="{{'TITLE.TITLE_NEW_SHIFT' | translate}}"
                        *ngIf="CheckAuth_Dept_Action(Model.PropertyId, Model.DeptId, _AuthActionCodes.SaveShift) && Model.DeptId != 0">
                    <i class="fas fa-plus-square fa-fw"></i>
                </button>

                <button class="btn btn-default border bg-white" title="{{'TITLE.TITLE_SAVE_AS' | translate}}"
                        [disabled]="Model.ShiftName==''" (click)="SaveAsShift()"
                        *ngIf="CheckAuth_Dept_Action(Model.PropertyId, Model.DeptId, _AuthActionCodes.SaveShift)">
                    <i class="fas fa-save"></i><i class="fas fa-save"></i>

                </button>

                <button class="btn btn-default border bg-white" (click)="addNotes.Open(saveShiftResponse)"
                        *ngIf="Model.DeptId != 0" [disabled]="Model.ShiftName ==''"
                        title="{{'TITLE.TITLE_NOTES' | translate}}">
                    <i class="far fa-sticky-note fa-fw"></i>
                </button>
                <button class="btn btn-default border bg-white" title="{{'TITLE.TITLE_LEGENDS' | translate}}"
                        *ngIf="Model.DeptId != 0" (click)="OpenKeyModal()">
                    <i class="fas fa-key fa-fw"></i>
                </button>
                <button class="btn btn-default border bg-white" title="{{'TITLE.TITLE_REFRESH' | translate}}"
                        *ngIf="Model.DeptId != 0" (click)="Refresh()">
                    <i class="fas fa-sync-alt fa-fw"></i>
                </button>
            </div>
        </div>
    </div>
    <div class="shiftSetup-table"
         *ngIf="CheckAuth_Dept_Action(Model.PropertyId, Model.DeptId, _AuthActionCodes.ShiftSetupview)">
        <div *ngIf="SectionRendered.showProgress">
            <sk-wave [isRunning]="SectionRendered.progress <= 100"></sk-wave>
        </div>

        <table class="table">
            <ng-container #sectionContainer></ng-container>
        </table>
    </div>
</div>

<ng-template #sectionItem let-section="section" let-index1="index1">
    <tr>
        <td class="text-truncate p-0" *ngFor="let skill of section.Skills;let index2 = index;"
            [style.width.%]="columnWidth">
            <div class="row my-2 pr-3 no-gutters" *ngIf="index1 == 0">
                <div class="font-weight-bold" [ngClass]="index2 == 0 ? 'firstSkill' : ''" translate>
                    {{skill.Name}}
                </div>
            </div>
            <div class="row grdHeader">
                <div class="d-flex" id="{{'section_'+section.Id}}" *ngIf="index2 == 0">
                    <div class="d-flex pointer" (click)="section.isOpen = !section.isOpen">
                        <div [hidden]="section.isOpen">
                            <i class="fas fa-chevron-down fa-fw"></i>
                        </div>
                        <div [hidden]="!section.isOpen">
                            <i class="fas fa-chevron-up fa-fw"></i>
                        </div>
                        <div class="font-weight-bold"> {{section.Name}} </div>
                    </div>
                    <a title="{{'TITLE.TITLE_MAP_STAFF_SECTION' | translate}}" class="text-success"
                       (click)="Model.SkillId = 0; Model.SectionId = section.Id; staffSkillSection.Open(Model)">
                        <i class="fas fa-user-plus fa-fw mx-2"></i>
                    </a>
                    <a (click)="sectionLocation.Open(section.Id)"
                       title="{{'TITLE.TITLE_MAPPED_LOCATION' | translate}}">
                        <i class="fas fa-info-circle fa-fw ml-2"></i>
                    </a>
                </div>
                <div *ngIf="index2 > 0" class="pointer w-100"
                     (click)="section.isOpen = !section.isOpen">&nbsp;</div>
            </div>
            <div *ngIf="section.isOpen">
                <div class="d-flex py-2 pr-3 text-left" *ngFor="let staff of skill.Staff"
                     [ngClass]="index2 == 0 ? 'firstSkill' : ''">
                    <div title="{{staff.IsLoggedIn ? ('TITLE.TITLE_LOGGED_IN' | translate) : ('TITLE.TITLE_LOGGED_OUT' | translate)}}">
                        <button class="btn btn-default bg-white p-0 mr-1"
                                [ngClass]="staff.IsLoggedIn ? 'LoggedInStatus' : 'LoggedOutStatus'"
                                [disabled]="staff.StaffId == masterService.LoggedInUserData.StaffId ? false : !CheckAuth_Dept_Action(Model.PropertyId, Model.DeptId, _AuthActionCodes.ServiceStaff_Login_Logout)"
                                (click)="shiftStaffInOut.Open(staff, Model.PropertyId, !staff.IsLoggedIn)"
                                [ngSwitch]="staff.MultipleSections">
                            <span *ngSwitchCase="true"><i class="fas fa-user-friends fa-fw"></i></span>
                            <span *ngSwitchCase="false"><i class="fas fa-user fa-fw"></i></span>
                        </button>
                    </div>
                    <!--<button class="btn btn-default bg-white p-0" [ngClass]="staff.HasDevices ? 'HasDeviceIcon_Color' : 'HasNoDeviceIcon_Color'" title="{{'TITLE.TITLE_ADD_EDIT_DEVICES' | translate}}" [disabled]="!CheckAuth_Dept_Action(Model.PropertyId, Model.DeptId, _AuthActionCodes.ServiceStaff_EditDeviceType)" (click)="deviceDetail.Open(staff.StaffId, Model)"><i class="fas fa-mobile fa-fw mx-1"></i></button>-->
                    <div class="text-primary staffName-width ellipsis">
                        <a (click)="Model.SectionId = 0; Model.SkillId = 0; SingleStaffId=staff.StaffId; staffSkillSection.Open(Model);">{{staff.Description}}</a>
                    </div>
                </div>
            </div>
            <div class="py-2 pr-3"
                 *ngIf="!skill.Staff.length>0 && section.isOpen && skill.Name != 'Unskilled'"
                 [ngClass]="index2 == 0 ? 'firstSkill' : ''" [style.width.%]="columnWidth">
                <button class="btn btn-sm btn-primary" type="button" id="AddStaff"
                        (click)="Model.SkillId = skill.Id; Model.SectionId = section.Id; staffSkillSection.Open(Model);"
                        translate>
                    BTN.BTN_ADD_STAFF
                </button>
            </div>
        </td>
    </tr>
</ng-template>

<ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h6 class="modal-title" translate>TITLE.TITLE_SAVE_SHIFT_NAME</h6>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <ErrorSummary [ErrorList]="FormErrors"></ErrorSummary>
        <div class="row no-gutters mb-2" *ngFor="let row of LanguageList; let index = index;">
            <div class="col-2">
                <label class="col-auto">{{row.Language}}</label>
            </div>
            <div class="col-1"></div>
            <div class="col-3">
                <input class="form-control rounded" type="text" placeholder="{{'PH.PH_SHIFT_NAME' | translate}}"
                       [(ngModel)]="MultiLingualShiftData[index].ShiftName" />
            </div>
            <div class="col-1"></div>
            <div class="col-5">
                <input class="form-control rounded" type="text" placeholder="{{'PH.PH_NOTES' | translate}}"
                       [(ngModel)]="MultiLingualShiftData[index].Notes" />
            </div>
        </div>

    </div>
    <div class="modal-footer">
        <button type="submit" class="btn btn-primary mr-3" (click)="AddNameToShift()" translate>BTN.BTN_SUBMIT</button>
        <button type="button" class="btn btn-secondary" (click)="d('dismiss')" translate>BTN.BTN_CANCEL</button>
    </div>
</ng-template>

<ng-template #activateShift let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h6 class="modal-title" translate>TITLE.TITLE_CONFIRM_ACTION</h6>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div translate>TITLE.TITLE_SELECT_REQUIRED_ACTION</div>
        <!--<ErrorSummary [ErrorList]="FormErrors"></ErrorSummary>
        <div class="mb-3"><span translate>LBL.CONFIRM_ACTIVATE_SHIFT</span></div>
        <div class="custom-control custom-radio custom-control-inline">
            <input type="radio" id="active" class="custom-control-input" [value]="true" [(ngModel)]="saveShiftResponse.IsShiftActivated">
            <label class="custom-control-label" for="active" translate>LBL.YES</label>
        </div>
        <div class="custom-control custom-radio custom-control-inline">
            <input type="radio" id="inactive" class="custom-control-input" [value]="false" [(ngModel)]="saveShiftResponse.IsShiftActivated">
            <label class="custom-control-label" for="inactive" translate>LBL.NO</label>
        </div>-->
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary"
                *ngIf="CheckAuth_Dept_Action(Model.PropertyId, Model.DeptId, _AuthActionCodes.ShiftActivate)"
                (click)="DisableModalOpenEvent = false;ActivateAndSave(true)" translate>
            BTN.BTN_SAVE&ACTIVATE
        </button>
        <button type="button" class="btn btn-secondary"
                *ngIf="CheckAuth_Dept_Action(Model.PropertyId, Model.DeptId, _AuthActionCodes.SaveShift)"
                (click)="DisableModalOpenEvent = false;ActivateAndSave(false)" translate>
            BTN.BTN_SAVE
        </button>

        <button type="button" class="btn btn-outline-secondary" (click)="d('dismiss')" translate>BTN.BTN_CANCEL</button>
    </div>

</ng-template>

<ng-template #shiftSetupKey let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h6 class="modal-title" translate>TITLE.TITLE_KEY</h6>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body container-fluid">
        <div class="row">
            <div class="col-6 pr-0 d-flex">
                <div class="col-1 LoggedInStatus px-0"><i class="fas fa-user"></i></div>
                <div class="pl-0" translate>
                    ICON_DEF.ICON_DEF_LOGGIN_USER
                </div>
            </div>
            <div class="col-6 d-flex">
                <div class="col-1 LoggedOutStatus  px-0"><i class="fas fa-user"></i></div>
                <div class="pl-0" translate>
                    ICON_DEF.ICON_DEF_LOGGED_OUT
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 pr-0 d-flex">
                <div class="col-1 HasDeviceIcon_Color px-0"><i class="fas fa-mobile"></i></div>
                <div class="pl-0" translate>
                    ICON_DEF.ICON_DEF_HAS_DEVICE
                </div>
            </div>
            <div class="col-6 d-flex">
                <div class="col-1 HasNoDeviceIcon_Color  px-0"><i class="fas fa-mobile"></i></div>
                <div class="pl-0" translate>
                    ICON_DEF.ICON_DEF_HAS_NO_DEVICE
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 pr-0 d-flex">
                <div class="col-1  px-0"><i class="fas fa-user-friends"></i></div>
                <div class="pl-0" translate>
                    ICON_DEF.ICON_DEF_MULTIPLE_LOGIN_LOGOUT
                </div>
            </div>
            <div class="col-6 d-flex">
                <div class="col-1 px-0"><i class="fas fa-pencil-alt"></i></div>
                <div class="pl-0" translate>
                    ICON_DEF.ICON_DEF_EDIT_SHIFT
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 pr-0 d-flex">
                <div class="col-1 px-0"><i class="fas fa-plus-square"></i></div>
                <div class="pl-0" translate>
                    ICON_DEF.ICON_DEF_ADD_NEW_SHIFT
                </div>
            </div>
            <div class="col-6 d-flex">
                <div class="col-1 px-0"><i class="fas fa-save"></i><i class="fas fa-save"></i></div>
                <div class="pl-0" translate>
                    ICON_DEF.ICON_DEF_SAVE_AS
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 pr-0 d-flex">
                <div class="col-1 px-0"><i class="far fa-sticky-note"></i></div>
                <div class="pl-0" translate>
                    ICON_DEF.ICON_DEF_PROFILE_NOTES
                </div>
            </div>
            <div class="col-6 d-flex">
                <div class="col-1 px-0"><i class="fas fa-sync-alt"></i></div>
                <div class="pl-0" translate>
                    ICON_DEF.ICON_DEF_REFRESH
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 pr-0 d-flex">
                <div class="col-1 px-0">
                    <i class="fas fa-plus"></i>
                </div>
                <div class="pl-0" translate>
                    ICON_DEF.ICON_DEF_EXPAND_ALL
                </div>
            </div>
            <div class="col-6 d-flex">
                <div class="col-1 px-0"><i class="fas fa-minus"></i></div>
                <div class="pl-0" translate>
                    ICON_DEF.ICON_DEF_COLLAPSE_ALL
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 pr-0 d-flex">
                <div class="col-1 px-0"><i class="fas fa-info-circle"></i></div>
                <div class="pl-0" translate>
                    ICON_DEF.ICON_DEF_SECTION_LOCATION
                </div>
            </div>
            <div class="col-6 d-flex">
                <div class="col-1 px-0"><i class="fas fa-user-plus"></i></div>
                <div class="pl-0" translate>
                    ICON_DEF.ICON_DEF_MAP_STAFF_SECTION
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 pr-0 d-flex">
                <div class="col-1 px-0"><i class="fas fa-sort"></i></div>
                <div class="pl-0" translate>
                    ICON_DEF.ICON_DEF_SORT
                </div>
            </div>
            <div class="col-6 d-flex">
                <div class="col-1 usr-info"><i class="fas fa-info-circle"></i></div>
                <div class="pl-3" translate>
                    ICON_DEF.ICON_DEF_USR_INFO
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer ">
        <button type="button" class="btn btn-primary mr-3" (click)="c('close')" translate>BTN.BTN_OK</button>
    </div>

</ng-template>

<Department #department (DepartmentChange)="SetShiftRequest($event);"></Department>

<StaffSkillSectionMap #staffSkillSection [SaveShiftResponse]="saveShiftResponse" [AllStaffList]="AllStaffList">
</StaffSkillSectionMap>

<SectionLocation #sectionLocation></SectionLocation>

<DeviceDetail #deviceDetail [AllDeviceData]="ShiftResponseModel.ListStaffDevices"
              (DeviceUpdated)="UpdateDeviceData($event)"></DeviceDetail>

<AddNotes #addNotes></AddNotes>

<ShiftStaffInOut #shiftStaffInOut [SectionSkillStaffData]="SectionSkillStaffData" [StaffList]="AllStaffList"
                 (StaffUpdated)="UpdateStaff($event)"></ShiftStaffInOut>

<DeleteObject #deleteObject (ObjectDeleted)="DeleteShift($event)"></DeleteObject>

<MultipleLoginLogout #multipleLoginLogout [SaveShiftResponse]="saveShiftResponse" [AllStaffList]="AllStaffList">
</MultipleLoginLogout>
